export default {
  validate: function (value) {
    return /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9])/.test(value)
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/passwordChar.js